import React from "react";
import { useFormContext } from "react-hook-form";

import { StationHookFormSelect } from "../../components";
import { StyledCell, StyledStack } from "./styles";

const ReworkStationTableAddRow = ({ handleAdd = () => {} }) => {
  const prefix = "addrow";

  const { getValues, setValue } = useFormContext();

  const value = {
    stationId: null,
  };

  const onFieldUpdate = (field) => {
    const value = getValues(`${prefix}.${field}`);
    handleAdd({ [field]: value });
    setValue(prefix, {});
  };

  return (
    <StyledStack sx={{ backgroundColor: "hubColors.mainFocusLighter2" }}>
      <StyledCell />
      <StationHookFormSelect
        label={null}
        name={`${prefix}.stationId`}
        value={value.stationId}
        onChange={() => onFieldUpdate("stationId")}
        department={5}
        required={false}
      />
      <StyledCell />
    </StyledStack>
  );
};

export default ReworkStationTableAddRow;
